import {EvalEnv} from '@packages/systems/wfdl';
import {weakMemo} from '@packages/utilities/memo';
import {localesListItemVariable, localesListActiveItemVariable} from '../types';

const EMPTY_DEFAULT_LOCALE = {
  tag: '',
  displayName: '',
  displayImageId: '',
  subdirectory: '',
  pageId: '',
  active: false,
} as const;

/**
 * We are adding an empty default locale here to avoid some errors from evalNodeBindings.
 * Long term Platform team needs to take a look at revamping evalNodeBindings
 * to either not walk the whole tree or have the same logic for appending the env data as
 * we do in the EvalElement while rendering.
 *
 * @see public/js/designer-flux/components/CanvasBody.tsx
 * @see packages/systems/render-atoms/server/index.ts
 */
export const addEmptyDefaultLocaleToAvoidErrors = weakMemo(
  (env: EvalEnv.EvalEnvType) =>
    EvalEnv.insertValue(
      EvalEnv.insertValue(
        env,
        localesListActiveItemVariable,
        EMPTY_DEFAULT_LOCALE
      ),
      localesListItemVariable,
      EMPTY_DEFAULT_LOCALE
    )
);
